/* eslint func-names: 0 */
// Prepend a code menu for each set of contiguous blocks
// This menu is hidden unless the preferred language is not available
// in the group of code blocks i.e. show a fallback
function setupLanguageMenuForCodeGroup($element, $codeBlocksGroup, currentLanguage) {
  const languages = [];
  const { supportedLanguages, html } = this;
  const { menuItem, codeBlockMenu, groupNote } = html;

  $codeBlocksGroup.each(function () {
    const $this = $(this);
    if ($this.prop('tagName') !== 'BR') {
      languages.push($this.attr('lang'));
    }
  });

  const menuItems = Object.keys(supportedLanguages)
    .filter((langId) => languages.indexOf(langId) + 1 && !/default/i.test(langId))
    .map(menuItem.bind(this))
    .join('');

  $codeBlocksGroup.first().before(codeBlockMenu(menuItems));

  let codeGroupHasLanguage = false;
  $element
    .parent()
    .find('button')
    .each(function () {
      const $this = $(this);
      if ($this.attr('lang') === currentLanguage) {
        $this.addClass('active');
        codeGroupHasLanguage = true;
      }
    });

  const lastMenuItem = $element.parent().find('button').last().parent();

  // Add warning note to toolbar
  // if the selected language isn't present
  lastMenuItem.after(groupNote(!codeGroupHasLanguage));
}

// Set up all the wrappers around code blocks needed for styling
// Also group contiguous code blocks with a unique data-lang-code-group

export default function wrapAndGroupCodeBlocks() {
  let groupId = 0;

  const currentLanguage = this.getCurrentLanguage();
  const { navigationLanguages = [] } = this;
  const noLanguages = navigationLanguages.length === 0;

  const setupLangMenu = (node, codeBlocksGroup) => {
    return setupLanguageMenuForCodeGroup.call(this, node, codeBlocksGroup, currentLanguage);
  };

  return $('pre[lang], blockquote.definition > p.definition > span').each(function () {
    let $codeBlocksGroup;
    let wrappingDiv;
    const $this = $(this);
    if ($this.parents('[data-lang-code-group]').length) {
      return;
    }

    if (!noLanguages) {
      // Group contiguous sibling code blocks if they are not already grouped
      $codeBlocksGroup = $this.prevUntil(':not(pre)').addBack().add($this.nextUntil(':not(pre)'));
    } else {
      $codeBlocksGroup = $this;
    }

    if ($this.is('pre')) {
      // If group has multiple code blocks, render a language selector
      if ($codeBlocksGroup.length > 1) {
        groupId += 1;
        wrappingDiv = `<div class="code-block-group" data-lang-code-group="${groupId}" />`;
        $codeBlocksGroup.wrapAll(wrappingDiv);
        setupLangMenu($this, $codeBlocksGroup);
      } else {
        wrappingDiv = '<div class="code-block-group" />';
        $codeBlocksGroup.wrapAll(wrappingDiv);
      }
    } else {
      // blockquote with span
      // If group has multiple code blocks, render a language selector
      if ($codeBlocksGroup.length > 1) {
        groupId += 1;
        wrappingDiv = `<div class="blockquote-definition" data-lang-code-group="${groupId}"/>`;
      } else {
        wrappingDiv = '<div class="blockquote-definition" />';
      }
      $codeBlocksGroup.wrapAll(wrappingDiv);
    }
  });
}

export { setupLanguageMenuForCodeGroup };
